var lx = lx || {};
lx.nav = lx.nav || {};

lx.nav.switch = function (pId, pLink, pNoConfirm, pProfile) {
    var lConfirm = true;
    if (pLink && pNoConfirm == undefined) lx.info.actionConfirm({type:"info",msg: apex.lang.getMessage("JS15"), js:"lx.nav.switch("+ pId +",'"+ pLink +"',true"+ (pProfile ? ","+pProfile : "") +" );"});
        //lConfirm = confirm(apex.lang.getMessage("JS15"));
    else {
        lx.load.add();
        apex.server.process("switchProfile", {
                x01: pId,
				x02: pProfile
            },{dataType: 'json'})
            .then(function (data) {
                if (data.err) {
                    lx.info.error(data.err);
                    lx.load.remove();
                } else if (pLink) lx.nav.redirect(pLink);
                else if (data.url) lx.nav.redirect(data.url);
                else location.reload();
            })
            .catch(function (err) {
                console.log(err);
                lx.load.remove();
            });
    }

    /*$s("P0_PROFILE_ID_SWITCH", pId);
    if (pLink) $s("P0_SWITCH_LINK", pLink);
    if (pLink && pNoConfirm == undefined) {
        apex.confirm(apex.lang.getMessage("JS15"), 'SWITCH_PROFILE');
    } else {
        lx.load.add(null, true);
        setTimeout(function () {
            apex.submit("SWITCH_PROFILE");
        }, 1);
    }*/
};

lx.nav.redirect = function (pUrl, pNewTab){
    if (pNewTab) apex.navigation.openInNewWindow(pUrl);
    else apex.navigation.redirect(pUrl);
};

lx.nav.itemLink = function (pItem, pNewTab){
    var lLink = $v(pItem);
	console.log("itemLink1");
    if (lLink.startsWith("javascript")) eval(lLink);
    else if (pNewTab) apex.navigation.openInNewWindow(lLink);
    else apex.navigation.redirect(lLink);
};

lx.nav.labelLink = function (pThis, pNewTab){
	console.log("labelLink");
    lx.nav.itemLink( $(pThis).attr("link-item"), pNewTab );
}

lx.nav.lxLoad = function (pUrl, pOverlay) {
    if (pUrl) {
        //$("body").append('<div class="lxLoading"></div>');
        $("body").append('<div class="lxLoadingBar"><div class="lxLoadingProgress"></div></div>');
        setTimeout(function () {
            apex.navigation.redirect(pUrl);
        }, 1);
    } else if (pOverlay) {
        $("body").append('<div class="lxLoading"></div>');
        $("body").append('<div class="lxLoadingBar"><div class="lxLoadingProgress"></div></div>');
    } else {
        $("body").append('<div class="lxLoadingBar"><div class="lxLoadingProgress"></div></div>');
    }

};

lx.nav.setRightCurrent = function (pId){
    $("#"+pId).addClass('is-active').siblings().removeClass('is-active ');
};

lx.nav.setTabCurrent = function (pId, pColor){
	//console.log('pColor =' + pColor);
    $("#"+pId).addClass('is-active').css({
    "color": pColor/*,        
    "border-color": pColor   */ 
  }).siblings().removeClass('is-active ').removeAttr("style");
};

lx.nav.setTabCurrentMs = function (evt, tabName, tabClass, tabType, tabId) {
	var i, tabcontent, tablinks;
	tabcontent = document.getElementsByClassName(tabClass);
	for (i = 0; i < tabcontent.length; i++) {
		tabcontent[i].style.display = "none";
	}
	tablinks = document.getElementsByClassName(tabType);
	for (i = 0; i < tablinks.length; i++) {
		tablinks[i].className = tablinks[i].className.replace(" active", "");
	}
	document.getElementById(tabName).style.display = "block";
	if (tabId) {$("#"+tabId).addClass(" active");}
	else {
	  evt.currentTarget.className += " active";
	}
	if (tabName == 'eventData' || tabName == 'workData') {
		document.getElementById("lxProfReportFilters").style.display = "block";
		if (tabName == 'eventData') { 
		  $("#lxProfReportFilters .lxProfShortListHdr").text(lx.tran.get('EVENT_ATTENDANCE'));
		}  
		if (tabName == 'workData') { 
		  $("#lxProfReportFilters .lxProfShortListHdr").text(lx.tran.get('WORK_ATTENDANCE'));
		}  
	}	
	else {
		document.getElementById("lxProfReportFilters").style.display = "none";
	}
};

/* TODO delete before migration */
lx.nav.pageLink = function (pPage, pItems, pValues, pCallback) {
    alert('lx.nav.pageLink function is a security liability, other way should be used for this implementation!')
    $.ajax({
        url: "wwv_flow.show",
        dataType: "html",
        traditional: true,
        cache: false,
        type: "POST",
        data: {
            p_flow_id: $v("pFlowId"),
            p_flow_step_id: $v("pFlowStepId"),
            p_instance: $v("pInstance"),
            p_request: "APPLICATION_PROCESS=pageLink",
            x01: pPage,
            x02: pItems,
            x03: pValues
        },
        success: function (d) {
            pCallback(d);
        }
    });
};



var redirect = lx.nav.redirect;
var lxLoad = lx.nav.lxLoad;
var pageLink = lx.nav.pageLink;